//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import signHead from './components/sign-head/index.vue'
export default {
  name: 'rule',
  components: { signHead },
  data() {
    return {

    }
  },
  created() {},
  methods: {}
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/sign/rule.vue